(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lph-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lph-product-carousel')) {
  customElements.define('lph-product-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.track = this.querySelector('.lph-carousel__track');
      this.slides = [...this.querySelectorAll('.lph-carousel__slide')];
      this.dots = [...this.querySelectorAll('[data-slide]')];
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => this.go(this.index + Number(button.dataset.direction)), options));
      this.dots.forEach((button, index) => button.addEventListener('click', () => this.go(index), options));
      this.track.addEventListener('scroll', () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
      }, { ...options, passive: true });
      this.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
      }, options);
      this.update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      cancelAnimationFrame(this.frame);
      this.initialized = false;
    }
    go(index) {
      const target = (index + this.slides.length) % this.slides.length;
      this.track.scrollTo({ left: target * this.track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    update() {
      this.index = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / this.track.clientWidth)));
      this.dots.forEach((button, index) => {
        if (index === this.index) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
